<template>
  <ExpansionTable
    :list="list"
    :pagination="pagination"
    :ordering="filters.ordering"
    :loading="isLoading"
    :skeleton="isLoadingAsyncData"
    :readonly="readonly"

    :title="pageTitle"
    :creatable="creatable"

    @change:pagination="onChangePagination"
    @change:sort="onChangeSort"

    @action:create="onActionCreate"
    @action:edit="onActionEdit"
    @action:view="onActionView"
    @action:delete="onActionDelete"
    @action:import-data="onActionParse"
    @action:import-curators="onActionUpload"
    @action:validate-forms="onValidateForms"
    @action:delete-level1-experts="onDeleteLevel1Experts"
  />
</template>

<script>
import { MunMehApi } from '@/api/resources'
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { PublicationMunMehModel as Model } from './Model'
import { PublicationMunMehStoreModule as StoreModule } from './store'
import {
  createPublicationMunMehImportModal,
  createPublicationMunMehDataModal,
  createPublicationMunMehModal,
  createPublicationMunMehDeleteExpert1Modal,
} from './utils'

import ExpansionTable from './components/PublicationMunMehExpansionTable.vue'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'ViewPublicationMunMehList',
  components: {
    ExpansionTable,
  },
  mixins: [
    listMixin,
  ],
  props: {
    publication: {
      type: Object,
      required: true,
      validator: (prop) => (
        prop
          && 'id' in prop
      ),
    },
  },
  data() {
    return {
      defaultParams: {
        publication_id: this.publication.id,
      },
    }
  },
  computed: {
    readonly() {
      return !this.$access(Permissions.edit)
    },
    creatable() {
      return this.$access(Permissions.create)
    },
  },
  methods: {
    async onValidateForms(payload) {
      const api = new MunMehApi()
      try {
        const { data } = await api.checkForms(payload.id)
        const { forms_created_count } = data
        let msg = 'Не найдено участников без форм'
        if (forms_created_count > 0) {
          msg = `Было создано форм: ${forms_created_count}`
        }
        this.$notice.info(`Формы проверены. ${msg}`)
      } catch (e) {
        this.$notice.errors(e)
      }
    },
    async onActionParse(data) {
      const propsData = { munMehId: data.id }
      const modal = await createPublicationMunMehDataModal(this, propsData)
      return modal.open()
    },
    async onActionUpload(data) {
      const propsData = { munMehId: data.id }
      const modal = await createPublicationMunMehImportModal(this, propsData)
      return modal.open()
    },
    async onDeleteLevel1Experts(data) {
      const propsData = { munMehId: data.id }
      const modal = await createPublicationMunMehDeleteExpert1Modal(this, propsData)
      return modal.open()
    },
    onActionCreate() {
      const readonly = false
      this.onOpenModal(null, readonly)
    },
    onActionEdit(data) {
      const readonly = false
      this.onOpenModal(data, readonly)
    },
    onActionView(data) {
      const readonly = true
      this.onOpenModal(data, readonly)
    },
    async onActionDelete(data) {
      await this.onDeleteWithRefresh(data, this.defaultParams)
    },
    async onOpenModal(data, readonly) {
      const propsData = this.getPropsData(data, readonly)
      const modal = await createPublicationMunMehModal(this, propsData)
      await modal.open()
      this.onGetData(this.filters)
    },
    getPropsData(data, readonly = false) {
      const action = (payload) => {
        const options = {
          ...this.defaultParams,
          payload: { ...payload, ...this.defaultParams },
          id: payload.id,
        }

        const promise = payload.id
          ? this.update(options)
          : this.create(options)

        return promise
      }

      const propsData = {
        data,
        readonly,
        viewOnly: this.readonly,
        publication: this.publication,
        actionSave: action,
        actionDelete: this.onActionDelete,
        successText: data ? Model.response_success.update : Model.response_success.create,
        errorText: data ? Model.response_error.update : Model.response_error.create,
        ...this.defaultParams,
      }

      return propsData
    },
  },
}
</script>
